import { render, staticRenderFns } from "./ActionDetailsModal.vue?vue&type=template&id=44dc1b6a&"
import script from "./ActionDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./ActionDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports